import '../helper/global-jquery';
import { getWindowSize, getDeviceType } from '../helper';

const SCROLL_DOWN_BTN = document.querySelector('.vd-button--scroll-down');
const HERO = document.querySelector('.vd-section--hero.version--extra-large') || document.querySelector('.vd-section--hero.version--illustration') ;
let lastWindowWidth = getWindowSize().width;


const handleScrollDown = () => {
	const $anchor = $(".body__container");

	$([document.documentElement, document.body]).animate({
		scrollTop: $anchor.offset().top
	}, 400);
}

const setImageHeight = (front, img) => {
	const device = getDeviceType();
	const isMobile = !window.matchMedia('only screen and (min-width: 768px)').matches;
	
	if (front) {
		const frontHeight = front.clientHeight;
		const vh = window.innerHeight;
	
		if (isMobile || device == 'mobile') img.style.height = `${vh - frontHeight}px`;
		else img.style.height = '100vh';
	}
}

const setHeroBackHeight = (front, back) => {
	if (front) {
		const frontHeight = front.clientHeight;
		const vh = window.innerHeight;
	
		back.style.height = `${vh - frontHeight}px`;

		if (frontHeight >= 0 && getWindowSize().height <= 760) {
			HERO.querySelector('.hero__image.hero__image--svg').style.display = 'none';
		} else {
			HERO.querySelector('.hero__image.hero__image--svg').style.display = 'block';
		}
	}
}

const init = () => {
	const front = HERO.querySelector('.hero__front');
	const back = HERO.querySelector('.hero__back');
	const imageJpg = HERO.querySelector('.hero__back .vd-image-container--jpg img');
	const imagesSVG = HERO.querySelectorAll('.hero__back .vd-image-container--svg img');
	const illustrationSVG = HERO.querySelector('.hero__image.hero__image--svg')

	if (imageJpg) {
		setImageHeight(front, imageJpg);
	}

	if (imagesSVG) {
		imagesSVG.forEach((el) => {
			setImageHeight(front, el);
		})
	}

	if (illustrationSVG) setHeroBackHeight(front, back);
}



// EVENTS
if (SCROLL_DOWN_BTN) SCROLL_DOWN_BTN.addEventListener('click', () => handleScrollDown());
// if (HERO) {
// 	window.addEventListener('load', () => init());
// 	window.addEventListener("resize", (e) => {
// 		if (lastWindowWidth !== getWindowSize().width) {
// 			init();
// 			lastWindowWidth = getWindowSize().width;
// 		}
// 	});
// }